
  export const style = {
    api: {
      apiProduction: "https://cury.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: null,
      nameProfile: "Cury",
      hostHeader: "cury",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_cury.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/secondary_logo_client_cury.png",
      browserLogo: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/favicon_client_cury.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_cury.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "Cury",
      nameScore: "BlocosCoins",
      nameStore: "Loja",
      nameAcademy: localStorage.getItem("nameAcademy") || "Cursos",
      nameTeam: localStorage.getItem("nameTeam") || "Time",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Ferramentas",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#283A97",
      secondaryColor: localStorage.getItem("secondaryColor") || "#283A97",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: false,
      externalUse: false,
      customClient: true,
      customMenuItem: true,
      autoRegister: false,
      recaptchaVersion: "V2",
      showBirthday: "true"
    },
  };
